export const engagementCanvasComparisonReportsCanvasesAppGroupId =
  "/engagement/canvas_comparison_reports/canvases(/:app_group_id)";
